class URLSearchParamsHelper {
  constructor(queryString) {
    this.query = {};
    if (queryString) {
      queryString
        .replace(/^\?/, "")
        .split("&")
        .forEach((pair) => {
          const [key, value] = pair.split("=");
          this.append(decodeURIComponent(key), decodeURIComponent(value));
        });
    }
  }

  append(key, value) {
    this.query[key] = value;
  }

  delete(key) {
    delete this.query[key];
  }

  get(key) {
    return this.query[key];
  }

  getAll() {
    return this.query || {};
  }

  has(key) {
    return key in this.query;
  }

  set(key, value) {
    this.query[key] = [value];
  }

  toString() {
    return Object.keys(this.query)
      .map((key) =>
        this.query[key]
          .map(
            (value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join("&")
      )
      .join("&");
  }
}

export { URLSearchParamsHelper };
